<template>
    <div class="mediaArea">
        <div v-if="mediaPreview" class="image-preview mb-3">
            <b-img-lazy class="m-0" v-bind="lazyOption" :src="$configs.upload + mediaPreview.basename" alt="Image 1"></b-img-lazy>
        </div>
        <b-button type="button" variant="secondary" @click="mediaModal = true">{{ value ? buttonTextEdit || "Sửa hình ảnh" : buttonText || "Chọn hình ảnh"}}</b-button>
        <b-button v-if="value" type="button" class="ml-2" variant="danger" @click="removeImage">{{buttonTextRemove || "Xóa hình ảnh"}}</b-button>
        <b-modal title="Quản lý hình ảnh" size="xl" dialog-class="modal-full" v-model="mediaModal" @hidden="resetMedia" @ok="setImage">
            <b-tabs  v-model="tabIndex">
                <b-tab title="Thư viện">
                    <div class="mediaArea">
                        <div class="left col-media">
                            <div slot="header" class="mb-3 d-flex justify-content-between">
                                <b-form-input v-model="search" placeholder="Tìm kiếm"></b-form-input>
                            </div>
                            <!--List images-->
                            <div class="mediaListItem" v-if="filterMedia.length">
                                <div  class="item" v-for="image in filterMedia">
                                    <div @click="selectImage(image)" v-bind:class="{active: image === mediaActive}" class="inner">
                                        <b-img-lazy class="m-0" v-bind="lazyOption" :src="$configs.upload + image.thumbnail" alt="Image 1"></b-img-lazy>
                                    </div>
                                </div>
                            </div>
                            <div class="mediaListItem" v-else>
                                <b-alert show variant="warning">Không có hình ảnh</b-alert>
                            </div>
                        </div>
                        <div class="right col-media">
                            <div class="mediaActive" v-if="mediaActive">
                                <h3>Chi tiết hình ảnh</h3>
                                <div class="infos">
                                    <div class="preview">
                                        <img :src="$configs.upload + mediaActive.basename">
                                    </div>
                                    <div class="info">
                                        <p class="name">{{mediaActive.filename}}</p>
                                        <p class="size">{{mediaActive.createdAt | formatDate("DD/MM/YYYY")}}, {{(mediaActive.size / 1024).toFixed(2)}} KB</p>
                                    </div>
                                </div>
                                <div class="action">
                                    <span class="delete" @click="deleteMess">Xóa</span>
                                </div>
                                <div class="form">
                                    <label for="title">Title</label>
                                    <b-form-input id="title" v-model="mediaActive.title" placeholder="Enter title"></b-form-input>
                                    <label for="alt" class="mt-2">Alt</label>
                                    <b-form-input id="alt" v-model="mediaActive.alt" placeholder="Enter alt"></b-form-input>
                                </div>


                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Tải lên">
                    <div class="uploadArea">
                        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true" @vdropzone-success="this.uploadSuccess">
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Thả file vào đây để tải lên</h3>
                            </div>
                        </vue-dropzone>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    export default {
        name: 'MediaModal',
        props: ["value","buttonText","buttonTextRemove"],
        data () {
            return {
                dropzoneOptions: {
                    url: this.$configs.api + '/api/media',
                    thumbnailWidth: 150,
                    maxFilesize: 1,
                    method:"post",
                    acceptedFiles:"image/*",
                    dictInvalidFileType:"Chỉ được phép tải lên file ảnh",
                    dictFileTooBig:"Chỉ được phép tải lên file < {{maxFilesize}} Mb ",
                    headers: { "My-Awesome-Header": "header value" },
                },
                lazyOption:{
                    center: true,
                    fluidGrow: true,
                    blank: true,
                    blankColor: '#bbb',
                    width: 150,
                    height: 150
                },
                mediaModal: false,
                contentEditor:this.value,
                search:'',
                media:[],
                mediaActive:null,
                tabIndex:0
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        created(){
            this.getMedia();
        },
        computed: {
            filterMedia() {
                return this.media.filter(post => {
                    return post.filename.toLowerCase().includes(this.search.toLowerCase())
                })
            },
            mediaPreview(){
                if(this.value){
                    for(let i = 0; i < this.media.length; i++){
                        if(this.media[i]._id === this.value){
                            return this.media[i];
                        }
                    }
                }

                return false;

            }
        },
        methods:{
            selectImage(image){
                this.mediaActive = image;
                this.mediaActive.title = image.filename
            },
            setImage(){
                if(this.mediaActive && this.mediaActive._id){
                    this.$emit('input', this.mediaActive._id);
                }
            },
            getMedia(){
                this.$http.get(this.$configs.api + '/api/media')
                    .then( respons => {
                        try{
                            if(respons.data.data){
                                this.media = respons.data.data;
                                if(this.value){
                                    for(let i = 0; i < this.media.length; i++){
                                        if(this.media[i]._id == this.value){
                                            this.mediaActive = this.media[i];
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            this.$toasted.show(err.message,{
                                type: "error",
                                duration: 5000
                            });
                        }
                    })
                    .catch( err => {
                        this.$toasted.show(err.message,{
                            type: "error",
                            duration: 5000
                        });
                    });
            },
            deleteMess(){
                this.$toasted.show("Bạn có chắc chắn muốn xóa",{
                    type:"info",
                    theme:"outline",
                    duration:10000,
                    action : [
                        {
                            text : 'Hủy',
                            onClick : (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                        {
                            text : 'Xóa',
                            // router navigation
                            onClick : (e, toastObject) => {
                                toastObject.goAway(0);
                                this.deleteAction();
                            }
                        }
                    ]
                })
            },
            deleteAction(){
                this.$http.delete(this.$configs.api + `/api/media/${this.mediaActive._id}`)
                    .then(respons => {
                        this.mediaActive = null;
                        this.getMedia();
                        this.$toasted.success("Xóa thành công",{
                            duration:5000
                        });
                    })
                    .catch(err => {
                        this.$toasted.error(err.response.data.message,{
                            duration: 5000
                        });
                    });
            },
            resetMedia(){
                if(this.value){
                    for(let i = 0; i < this.media.length; i++){
                        if(this.media[i]._id === this.value){
                            this.mediaActive = this.media[i];
                        }
                    }
                }
            },
            removeImage(){
                this.$emit('input',null);
                this.mediaActive = null;
            },
            uploadSuccess(){
                this.$refs.myVueDropzone.removeAllFiles();
                this.tabIndex = 0;
                this.getMedia();
            }
        }
    }
</script>
<style scoped>
    .mediaListItem{
        margin: 0 -10px;
    }
    .mediaListItem:before,.mediaListItem:after{
        content: "";
        display: block;
        clear: both;
    }
    .mediaListItem .item{
        width: 10%;
        float: left;
        padding: 0 10px;
        margin-bottom: 20px;
        cursor: pointer;
    }
    .mediaListItem .item .inner{
        box-shadow:0 0 0 0 #0073aa;
        transition: all 0.1s;
        position: relative;
    }
    .mediaListItem .item .inner::before{
        content: '';
        width: 25px;
        height: 25px;
        display: block;
        border: 2px solid #0073aa;
        position: absolute;
        top: -5px;
        right: -5px;
        z-index: 9;
        background: #0073aa;
        opacity: 0;
        visibility: hidden;
        box-shadow: inset 0 0 0 1px #fff;
    }
    .mediaListItem .item .inner::after{
        content: '';
        display: block;
        width: 4px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: absolute;
        top: 2px;
        right: 5px;
        z-index: 10;
        opacity: 0;
        visibility: hidden;
    }
    .mediaListItem .item .active{
        box-shadow:0 0 0 5px #0073aa;
    }

    .mediaListItem .item .active::before,.mediaListItem .item .active::after{
        opacity: 1;
        visibility: visible;
    }

    .mediaListItem .item .active{

    }

    .mediaListItem .item img{
        width: 100%;
        margin: 0;
    }
    .uploadArea{
        display: flex;
        height: 100%;
        width: 100%;
        padding: 15px 15px 71px;
    }
    .uploadArea > *{
        width: 100%;
        border-style: dashed;
        align-content: center;
        align-items: center;
        display: flex;
        justify-content: center;
    }
</style>